import * as React from "react";
import "./tabSet.scss";

export default class TabSet extends React.Component<{}, {}> {
	render() {
		return (
			<div className={"m-tab-set"}>
				{this.props.children}
			</div>
		);
	}
}
